(() => {
    const $adminBar = document.querySelector('.admin-bar');
    const $siteHeader = document.querySelector('.site-header');
    const $siteHeaderInnerWrapper = document.querySelector('.site-header__inner-wrapper');
    const $siteHeaderInner = document.querySelector('.site-header__inner');
    const $siteHeaderContent = document.querySelector('.site-header__content');
    const $firstBlock = document.querySelector('.block--is-first-block');

    if (!$siteHeader) return;
    
    const enableSiteHeaderBG = () => {
        if (!$adminBar) {
            if ((window.innerWidth < 768 && window.scrollY >= 10) ||
                window.innerWidth >= 768 && window.scrollY >= 20) {
                    
                $siteHeader.classList.add('site-header--enable-bg');
            } else {
                $siteHeader.classList.remove('site-header--enable-bg');
            }
        }

        if ($adminBar) {
            if ((window.innerWidth < 601 && window.scrollY >= 56) ||
                window.innerWidth >= 601 && window.innerWidth < 768 && window.scrollY >= 15 ||
                window.innerWidth >= 768 && window.scrollY >= 20) {
                    
                $siteHeader.classList.add('site-header--enable-bg');
            } else {
                $siteHeader.classList.remove('site-header--enable-bg');
            }
        }
    };

    const firstBlockTopSpacing = () => {
        if (!$firstBlock || !$siteHeaderInnerWrapper) return;

        const $topPaddingEl = $firstBlock?.querySelector('.first-block-top-padding') ?? $firstBlock;
        const $bottomPaddingEl = $firstBlock?.querySelector('.first-block-bottom-padding');

        if ($topPaddingEl) {
            $topPaddingEl.style.paddingTop = `${$siteHeaderInnerWrapper?.clientHeight}px`;
        }

        if ($bottomPaddingEl) {
            $bottomPaddingEl.style.paddingBottom = `${$siteHeaderInnerWrapper?.clientHeight}px`;
        }
    }

    window.addEventListener('scroll', enableSiteHeaderBG);
    window.addEventListener('resize', firstBlockTopSpacing);

    enableSiteHeaderBG();
    firstBlockTopSpacing();
})();
